module.exports = __webpack_public_path__ + "img/check-mark.636c4342.png";